// extracted by mini-css-extract-plugin
export default {"viewWrapper":"DefaultViewCoontrol_viewWrapper__Vz0YP","labelView":"DefaultViewCoontrol_labelView__pH0gQ","valueView":"DefaultViewCoontrol_valueView__fSpjW"};